// extracted by mini-css-extract-plugin
export default {"listCharacters":"Cards_listCharacters__LHg+A","titleCards":"Cards_titleCards__2ELzT"};